import type { ReactNode } from 'react';

export interface EmptyStateProps {
  /** Was hier stehen wuerde, wenn es etwas gaebe. */
  title: string;
  /** Warum es leer ist — nicht die Feststellung, dass es leer ist. */
  children: ReactNode;
  /** Der naechste Schritt als Knopf. */
  action?: ReactNode;
  /** Ein einzelnes Zeichen als ruhiger Blickfang. */
  symbol?: string;
}

/**
 * Leerer Zustand.
 *
 * Ein leerer Bereich ist die beste Gelegenheit, etwas zu erklaeren — und die
 * am haeufigsten verschenkte. "Keine Eintraege" sagt einem Neuling nichts:
 * weder ob das ein Fehler ist, noch was er tun soll.
 *
 * Deshalb verlangt diese Komponente drei Dinge und laesst keines weg:
 * eine Ueberschrift, eine Begruendung und moeglichst den Weg nach vorn.
 */
export function EmptyState({ title, children, action, symbol }: EmptyStateProps) {
  return (
    <div className="empty" role="status">
      {symbol && (
        <span className="empty__symbol" aria-hidden="true">
          {symbol}
        </span>
      )}
      <p className="empty__title">{title}</p>
      <div className="empty__text">{children}</div>
      {action && <div className="empty__action">{action}</div>}
    </div>
  );
}
